import { render, staticRenderFns } from "./AMSBreadcrumb.vue?vue&type=template&id=3e8ab224&"
import script from "./AMSBreadcrumb.vue?vue&type=script&lang=ts&"
export * from "./AMSBreadcrumb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib'
installComponents(component, {VBreadcrumbs})
